import { BOOKINGS_SERVICE_PAGE_SECTION_ID, getBookingsRelativeUrl, getSectionRelativeUrl, getUrlQueryParams, isBookingsSectionInstalled, queryBuilder } from '@wix/bookings-catalog-calendar-viewer-utils';
import { UrlMappingsKeys } from '@wix/url-mapper-utils';
async function getServicePageRelativeUrl(_ref) {
  let {
    serviceSlug,
    wixCodeApi
  } = _ref;
  const customSegmentRelativeUrl = await (wixCodeApi.location.buildCustomizedUrl == null ? void 0 : wixCodeApi.location.buildCustomizedUrl(UrlMappingsKeys.BOOKINGS_SERVICE, {
    slug: serviceSlug
  }, {
    baseUrl: ''
  }));
  if (customSegmentRelativeUrl) {
    return customSegmentRelativeUrl;
  }
  let servicePageRelativeUrl;
  if (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_SERVICE_PAGE_SECTION_ID)) {
    servicePageRelativeUrl = await getSectionRelativeUrl(wixCodeApi, BOOKINGS_SERVICE_PAGE_SECTION_ID);
  } else {
    servicePageRelativeUrl = getBookingsRelativeUrl(wixCodeApi);
  }
  return servicePageRelativeUrl + `/${serviceSlug}`;
}
export async function navigateToBookingsServicePage(wixCodeApi, _ref2) {
  let {
    serviceSlug,
    referral,
    location
  } = _ref2;
  const query = queryBuilder({
    ...getUrlQueryParams(wixCodeApi),
    ...{
      referral,
      location
    }
  });
  const servicePageRelativeUrl = await getServicePageRelativeUrl({
    serviceSlug,
    wixCodeApi
  });
  return wixCodeApi.location.to(servicePageRelativeUrl + query);
}
//# sourceMappingURL=navigateToBookingsServicePage.js.map